import { BridgeComponent } from "@hotwired/hotwire-native-bridge"


// Customized version of https://github.com/joemasilotti/bridge-components/blob/main/web/controllers/toast_controller.js
// so that we can trigger an event on connect rather than a click.
export default class extends BridgeComponent {
  static component = "toast"

  connect() {
    this.#showToast()
  }

  #showToast() {
    const message = this.bridgeElement.bridgeAttribute("message")
    this.send("show", { message }, () => { })
  }
}